<ng-container *ngIf="timeline">
  <div *ngFor="let timeline of timeline">
    <app-timeline-point [timeline]="timeline" [position]="getPosition(timeline)"></app-timeline-point>
    <div class="connector" *ngIf="getPosition(timeline) !== timelinePositionEnum.last">
      <div class="center-line"></div>
    </div>
  </div>
</ng-container>
